import Panzoom from '@panzoom/panzoom/dist/panzoom.min';

class Gallery {
    constructor(elem, index) {
        this.gallery = elem;
        this.thumbs = elem.find('[data-gallery-thumb]');
        this.thumbsSlides = this.thumbs.children('.swiper-container');
        this.thumbItem = this.thumbs.find('.gallery__item');
        this.mainImage = elem.find('[data-gallery-main_img]');
        this.prevArrow = this.thumbs.find('.swiper-button-prev');
        this.nextArrow = this.thumbs.find('.swiper-button-next');
        this.count = this.gallery.attr('data-gallery') || 6;
        this.breakpoints =  {
            1200: {
                slidesPerView: 6
            },
            992: {
                slidesPerView: 4
            },
            544: {
                slidesPerView: 3
            }
        };

        if (this.gallery.attr('data-breakpoints')) {
            this.breakpoints = JSON.parse(this.gallery.attr('data-breakpoints'));
        }
    }

    init() {
        this.initGallery();
        // this.makeDynamic();
    }

    // Карусель свайпер для изображений
    initGallery() {
        window.productGallery = new window.Swiper(this.thumbsSlides[0], {
            spaceBetween: 11,
            slidesPerView: this.count,
            navigation: {
                prevEl: this.prevArrow,
                nextEl: this.nextArrow
            },
            breakpoints: this.breakpoints,
            observer: true,
            on: {
                observerUpdate: function() {
                    if (this.isBeginning && this.isEnd) {
                        this.navigation.prevEl.classList.add('visually-hidden');
                        this.navigation.nextEl.classList.add('visually-hidden');
                    } else {
                        this.navigation.prevEl.classList.remove('visually-hidden');
                        this.navigation.nextEl.classList.remove('visually-hidden');
                    }
                }
            }
        });

        const mainGallery = document.querySelector('.gallery__main-img .swiper-container');

        window.mainImgGallery = new window.Swiper(mainGallery, {
            thumbs: {
                swiper: window.productGallery
            }
        });

        document.querySelectorAll('.gallery__zoom').forEach((container) => {
            setTimeout(() => {
                const zoomer = new panZoom(container);
                zoomer.init();
            }, 200);
        })
    }

    // Инициализация первой миниатюры и Динамика при клике на миниатюру
    makeDynamic() {
        let _this = this;

        // Первый элемент активен
        let firstThumb = this.thumbsSlides.find('.swiper-slide').first().children('.gallery__item');
        if (firstThumb.length < 1) {
            return;
        }

        firstThumb.addClass('active');

        let isImage = !!firstThumb.data('image');
        if (isImage) {
            this.applyMainGallery(firstThumb.data('image'), false, isImage);
        } else {
            this.applyMainGallery(firstThumb.data('video'), firstThumb.data('poster'), isImage);
        }

        this.gallery.on('click', '.gallery__item', function () {
            // повторное присвоение для корректной работы при обновлении миниатюр
            _this.thumbItem = _this.thumbs.find('.gallery__item');

            if (!$(this).hasClass('active')) {
                _this.thumbItem.removeClass('active');
                $(this).addClass('active');

                isImage = !!$(this).data('image');
                if (isImage) {
                    _this.applyMainGallery($(this).data('image'), false, isImage);
                } else {
                    _this.applyMainGallery($(this).data('video'), $(this).data('poster'), isImage);
                }
            }
        });
    }

    // Изменяет основное изображение
    applyMainGallery(src, poster, isImage) {
        let _this = this;

        // Удалим предыдущий panZoom
        if (
            (typeof this.zoomer !== 'undefined')
            && this.zoomer.isInited
        ) {
            this.zoomer.destroy();
        }

        // Очистим блок от изображения или видео
        this.mainImage.empty();

        if (isImage) {
            // Нарисуем разметку для изображения и управляющие кнопки
            let imageZoomLayout = '';
            let zoomIconLayout = '';

            if (window.isGalleryFullScreen) {
                zoomIconLayout = '<div class="gallery__zoom--btn fullscreen" data-id="galleryFullscreen"><i class="fa fa-compress"></i></div>'
            } else {
                zoomIconLayout = '<div class="gallery__zoom--btn fullscreen" data-id="galleryFullscreen"><i class="fa fa-expand"></i></div>'
            }

            imageZoomLayout += '<div class="gallery__zoom">';
                imageZoomLayout += '<div class="gallery__zoom--image" data-id="zoomContainer"><img src="'+src+'" alt="" height="1" width="1"></div>';
                imageZoomLayout += '<div class="gallery__zoom--btn plus" data-id="zoomPlus"><i class="fa fa-plus"></i></div>';
                imageZoomLayout += '<div class="gallery__zoom--btn minus" data-id="zoomMinus"><i class="fa fa-minus"></i></div>';
                imageZoomLayout += '<div class="gallery__zoom--btn reset" data-id="zoomReset"><i class="fa fa-undo"></i></div>';
                imageZoomLayout += zoomIconLayout;
            imageZoomLayout += '</div>'; // .gallery__zoom

            this.mainImage.append(imageZoomLayout);

            // Инициируем новый panZoom
            setTimeout(() => {
                _this.zoomer = new panZoom();
                _this.zoomer.init();
            }, 200);

        } else {
            // Разметка для видео
            this.mainImage.append('<video src="'+src+'" poster="'+poster+'" controls="true">')
        }
    }
}

export {Gallery};

// Конструктор для увеличения фото
window.isGalleryFullScreen = false;
class panZoom {
    constructor(container = document) {
        this.isInited = false;
        this.panzoom = null;
        this.zoomContainer = container.querySelector('[data-id="zoomContainer"]');
        this.zoomPlus = container.querySelector('[data-id="zoomPlus"]');
        this.zoomMinus = container.querySelector('[data-id="zoomMinus"]');
        this.zoomReset = container.querySelector('[data-id="zoomReset"]');
        this.fullscreen = container.querySelector('[data-id="galleryFullscreen"]');
        this.max_scale = 4.5;
        this.scale = 1;
    }

    init() {
        let _this = this;

        this.panzoom = Panzoom(this.zoomContainer, {
            maxScale: this.max_scale,
            minScale: 1,
            startScale: 1,
            step: 0.5,
            panOnlyWhenZoomed: false,
            contain: 'outside',
            animate: true
        });

        let xStart = 0, yStart = 0,
            xEnd = 0, yEnd = 0;

        // Начальные значения координат (только целая часть)
        this.zoomContainer.addEventListener('panzoomstart', (event) => {
            xStart = Math.trunc(event.detail.x);
            yStart = Math.trunc(event.detail.y);
        });

        // Конечные значения координат (только целая часть)
        this.zoomContainer.addEventListener('panzoomend', (event) => {
            xEnd = Math.trunc(event.detail.x);
            yEnd = Math.trunc(event.detail.y);
        });

        // Динамика доступности кнопок управления
        this.zoomContainer.addEventListener('panzoomchange', (event) => {
            //console.log('event.detail = ', event.detail) // => { x: 0, y: 0, scale: 1 }

            if (event.detail.scale === 1) {
                this.zoomPlus.classList.remove('disabled');
                this.zoomMinus.classList.add('disabled');
                this.zoomReset.classList.add('disabled');
            } else if (event.detail.scale > 1 && event.detail.scale < this.max_scale) {
                this.zoomPlus.classList.remove('disabled');
                this.zoomMinus.classList.remove('disabled');
                this.zoomReset.classList.remove('disabled');
            } else if (event.detail.scale === this.max_scale) {
                this.zoomPlus.classList.add('disabled');
                this.zoomMinus.classList.remove('disabled');
                this.zoomReset.classList.remove('disabled');
                this.panzoom.zoom(1);
            }
        });

        this.isInited = true;

        this.zoomPlus.addEventListener('click', this.panzoom.zoomIn);
        this.zoomMinus.addEventListener('click', this.panzoom.zoomOut);
        this.zoomReset.addEventListener('click', this.panzoom.reset);

        this.zoomContainer.addEventListener('click', function() {
            setTimeout(function() {
                // Если не двигали картинку, увеличим её
                if (xStart === xEnd && yStart === yEnd) {
                    _this.panzoom.zoomIn();
                }
            }, 100);
        });

        // Переход в полноэкранный режим
        $(this.fullscreen).click(function () {
            window.isGalleryFullScreen = toggleFullScreen($('[data-gallery]')[0]);
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            let ios = false;

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                ios = true;
            }

            if (ios) {
                if ($('[data-gallery]').hasClass('fullscreen')) {
                    $(this).empty().append('<i class="fa fa-compress"></i>');
                } else {
                    $(this).empty().append('<i class="fa fa-expand"></i>');
                }
            } else {
                if (window.isGalleryFullScreen) {
                    $(this).empty().append('<i class="fa fa-compress"></i>');
                } else {
                    $(this).empty().append('<i class="fa fa-expand"></i>');
                }
            }
        });


        const exitHandler = () => {
            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                this.panzoom.reset();
                $('[data-id="galleryFullscreen"]').empty().append('<i class="fa fa-expand"></i>');
            }
        }

        document.addEventListener('fullscreenchange', exitHandler);
        document.addEventListener('webkitfullscreenchange', exitHandler);
        document.addEventListener('mozfullscreenchange', exitHandler);
        document.addEventListener('MSFullscreenChange', exitHandler);
    }

    destroy() {
        this.zoomPlus.removeEventListener('click', this.panzoom.zoomIn);
        this.zoomMinus.removeEventListener('click', this.panzoom.zoomOut);
        this.zoomReset.removeEventListener('click', this.panzoom.reset);
        this.panzoom.destroy();
        this.isInited = false;
    }
}

// Функция для перехода в полноэкранный режим
// спасибо: https://stackoverflow.com/questions/7179535/set-window-to-fullscreen-real-fullscreen-f11-functionality-by-javascript
function toggleFullScreen(elem) {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let ios = false;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        ios = true;
    }

    if (ios) {
        $('[data-gallery]').toggleClass('fullscreen');

        return false;
    }

    if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen) || (document.webkitCurrentFullScreenElement !== undefined && !document.webkitCurrentFullScreenElement)) {
        if (elem.requestFullScreen) {
            elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        } else if (elem.webkitEnterFullscreen) {
            elem.webkitEnterFullscreen();
        } else if (elem.webkitCurrentFullScreenElement) {
            elem.webkitCurrentFullScreenElement()
        }

        return true;
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.webkitEnterFullscreen) {
            document.webkitCancelFullscreen();
        } else if (document.webkitCurrentFullScreenElement) {
            document.webkitCurrentFullScreenElement();
        }

        return false;
    }
}


window.productGallery = null;
$(document).ready(()=>{
    let galleries = [];

    if ($('[data-gallery]').length > 0) {
        $('[data-gallery]').each(function(i) {
            galleries[i] = new Gallery($(this), i);
            galleries[i].init();
        });
    }
});
